import React from 'react'
import { checkTranslation, getObject, setObject, checkPermission } from '../../utils/useful'
import Modal from '../Modal'
import { getProcessStagesByPurchaseMethod } from '../../variables/adminWidgets'
import HttpServices from '../../utils/Http.services'
import DateInput from '../inputs/DateInput'
import TextAreaInput from '../inputs/TextAreaInput'
import FormViewer from '../FormViewer'
import { siteTheme } from '../../variables/config'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
class TableProfessionalStatusInput extends React.Component {
    state = {
        selectedStep: null,
        stepDate: new Date(),
        stepDescription: '',
        isLoading: false,
        viewDetailsStage: null,
        editHeadersOnly: false,
        viewInfoStage: null,
    }

    // Horizontal slider helpers for roadmap
    roadmapIsDragging = false
    roadmapStartX = 0
    roadmapScrollLeft = 0

    setRoadmapRef = (el) => {
        this.roadmapScrollContainer = el
    }

    handleRoadmapMouseDown = (e) => {
        if (!this.roadmapScrollContainer) return
        this.roadmapIsDragging = true
        this.roadmapStartX = e.pageX - this.roadmapScrollContainer.offsetLeft
        this.roadmapScrollLeft = this.roadmapScrollContainer.scrollLeft
    }

    handleRoadmapMouseLeave = () => {
        this.roadmapIsDragging = false
    }

    handleRoadmapMouseUp = () => {
        this.roadmapIsDragging = false
    }

    handleRoadmapMouseMove = (e) => {
        if (!this.roadmapIsDragging || !this.roadmapScrollContainer) return
        e.preventDefault()
        const x = e.pageX - this.roadmapScrollContainer.offsetLeft
        const walk = (x - this.roadmapStartX) * 1 // scroll speed
        this.roadmapScrollContainer.scrollLeft = this.roadmapScrollLeft - walk
    }

    scrollRoadmap = (direction) => {
        if (!this.roadmapScrollContainer) return
        const scrollAmount = 240 // roughly one card
        // RTL: visually "next" should move content to the left
        const delta = direction === 'next' ? -scrollAmount : scrollAmount
        this.roadmapScrollContainer.scrollBy({ left: delta, behavior: 'smooth' })
    }

    componentDidMount() {
        // Listen for the openStatusModal event
        window.addEventListener('openStatusModal', this.handleOpenStatusModalEvent)
    }

    componentWillUnmount() {
        window.removeEventListener('openStatusModal', this.handleOpenStatusModalEvent)
    }

    handleOpenStatusModalEvent = (event) => {
        const rawEventId = event.detail?.rowId
        const currentRowId = this.props.fullValues?._id || this.props.fullValues?.id
        if (rawEventId == null || currentRowId == null) return
        if (String(rawEventId) !== String(currentRowId)) return
        // In some screens, multiple status components can exist for the same row id
        // (e.g. duplicated renders). Guard: one open per logical click, not half a second of silence.
        const rowId = String(rawEventId)
        const now = Date.now()
        if (window.__openStatusModalGuard && window.__openStatusModalGuard.rowId === rowId && now - window.__openStatusModalGuard.at < 120) {
            return
        }
        window.__openStatusModalGuard = { rowId, at: now }
        this.openStatusModal()
    }

    openRoadmapModal = (e) => {
        const canChangeFromTable = this.props.header?.information?.canChangeFromTable
        if (!canChangeFromTable) {
            return // Don't open if canChangeFromTable is not true
        }
        if (this.roadmapModal) {
            this.roadmapModal.showModal()
            this.scrollToCurrentStage()
        }
        // Avoid bubbling to TableRow's openStatus → duplicate CustomEvent / guard eating the real open.
        if (e && typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }
    }

    // Method to open status modal (can be called from action handlers or events)
    openStatusModal = () => {
        if (this.roadmapModal) {
            this.roadmapModal.showModal()
            this.scrollToCurrentStage()
        }
    }

    scrollToCurrentStage = () => {
        setTimeout(() => {
            const container = this.roadmapScrollContainer
            const element = this.currentStageRef
            if (!container || !element) return

            const start = container.scrollLeft
            const target = element.offsetLeft - container.clientWidth / 2 + element.offsetWidth / 2
            const duration = 800
            const startTime = performance.now()

            const animate = (now) => {
                const elapsed = now - startTime
                const progress = Math.min(elapsed / duration, 1)
                const ease = 1 - Math.pow(1 - progress, 3) // ease-out cubic
                container.scrollLeft = start + (target - start) * ease
                if (progress < 1) requestAnimationFrame(animate)
            }
            requestAnimationFrame(animate)
        }, 100)
    }

    closeRoadmapModal = () => {
        if (this.roadmapModal) {
            this.roadmapModal.hideModal()
        }
        const currentRowId = this.props.fullValues?._id || this.props.fullValues?.id
        if (currentRowId != null && window.__openStatusModalGuard?.rowId === String(currentRowId)) {
            window.__openStatusModalGuard = null
        }
    }

    openStepModal = (stepKey, options = {}) => {
        const { editHeadersOnly = false } = options
        this.setState({ 
            selectedStep: stepKey,
            stepDate: new Date(),
            stepDescription: '',
            editHeadersOnly,
        }, () => {
            if (this.stepModal) {
                this.stepModal.showModal()
            }
        })
    }

    closeStepModal = () => {
        if (this.stepModal) {
            this.stepModal.hideModal()
        }
        this.setState({ selectedStep: null })
    }

    handleStepDateChange = (key, value) => {
        this.setState({ stepDate: value })
    }

    handleStepDescriptionChange = (key, value) => {
        this.setState({ stepDescription: value })
    }

    // Resolve current user type for legacy checks (requiredPermission strings, etc.)
    getCurrentUserType = () => {
        const user = this.props.user
        const fullValues = this.props.fullValues
        let userType = user?.info?.userType
            || fullValues?.userType
            || fullValues?.values?.userType
            || 'admin'
            if(userType === 'employee'){
                userType = 'admin'
            }
        return userType
    }

    getStagePermissionApplet = () =>
        this.props.variables?.applet ?? this.props.fullValues?.applet ?? null

    getPurchaseMethod = () =>
        this.props.fullValues?.values?.purchaseMethod
        || this.props.fullValues?.purchaseMethod
        || this.props.fullValues?.values?.purchase_method
        || null

    getFlowStages = () => getProcessStagesByPurchaseMethod(this.getPurchaseMethod())

    getFirstStageKey = () => {
        const keys = Object.keys(this.getFlowStages())
        return keys[0] || null
    }

    /** Stage whose `advanceFor` gates the "Go to Next Stage" button */
    getAdvancePermissionStage = () => {
        const flowStages = this.getFlowStages()
        const currentKey = this.getCurrentStatusKey()

        if (!currentKey) {
            const firstKey = this.getFirstStageKey()
            return firstKey ? flowStages[firstKey] : null
        }

        const nextStep = this.getNextStep()
        return nextStep ? flowStages[nextStep] : null
    }

    // Filter stages for status input based on statusVisibleFor (checkPermission on array)
    getStatusStages = () => {
        const applet = this.getStagePermissionApplet()
        const stagesForFlow = getProcessStagesByPurchaseMethod(this.getPurchaseMethod())
        return Object.fromEntries(
            Object.entries(stagesForFlow).filter(([_, stage]) => {
                if (!stage.statusVisibleFor || !Array.isArray(stage.statusVisibleFor)) return true
                return checkPermission(stage.statusVisibleFor, null, applet)
            })
        )
    }

    hasStageEditPermission = () => {
        return checkPermission('admin.permissions.edit', null, this.getStagePermissionApplet())
    }

    /** Per-stage advance permission from `processStages` in adminWidgets (`advanceFor`). */
    canAdvanceForStage = (stage) => {
        const advanceFor = stage?.advanceFor
        if (!advanceFor || (Array.isArray(advanceFor) && advanceFor.length === 0)) return true
        return checkPermission(advanceFor, null, this.getStagePermissionApplet())
    }

    /** View stage info — any permission in `infoVisibleFor` (OR), from adminWidgets processStages */
    canViewStageInfo = (stage) => {
        const infoVisibleFor = stage?.infoVisibleFor
        if (!infoVisibleFor || (Array.isArray(infoVisibleFor) && infoVisibleFor.length === 0)) return true
        return checkPermission(infoVisibleFor, null, this.getStagePermissionApplet())
    }

    getReadOnlyHeaders = (headers) => {
        if (!Array.isArray(headers)) return []
        return headers.map(h => ({
            ...h,
            information: {
                ...(h.information || {}),
                disabled: true,
                required: false,
            },
        }))
    }

    goToNextStep = () => {
        const nextStep = this.getNextStep()
        if (nextStep) {
            this.openStepModal(nextStep)
        }
    }

    viewStageDetails = (stageKey) => {
        this.setState({ viewDetailsStage: stageKey }, () => {
            if (this.detailsModal) {
                this.detailsModal.showModal()
            }
        })
    }

    closeDetailsModal = () => {
        if (this.detailsModal) {
            this.detailsModal.hideModal()
        }
        this.setState({ viewDetailsStage: null })
    }

    buildStageSaveBody = (selectedStep, newStatusValue) => {
        const { fullValues } = this.props
        const recordId = fullValues?._id || fullValues?.id
        if (!recordId) return null

        const stageHeaders = this.getStatusStages()[selectedStep]?.headers || []
        let formData = null

        if (stageHeaders.length > 0) {
            if (!this.stageForm || !this.stageForm.getForm) return null
            formData = this.stageForm.getForm()
            // getForm returns null when required fields fail validation
            if (!formData) return null
        }

        let body = { _id: recordId }
        const applet = this.getStagePermissionApplet()
        if (applet) {
            body.applet = typeof applet === 'object' ? (applet._id || applet.id) : applet
        }

        if (formData && stageHeaders.length > 0) {
            stageHeaders.forEach(h => {
                if (!h?.key) return
                const value = getObject(formData, h.key)
                if (value !== undefined) {
                    body = setObject(body, h.key, value)
                }
            })

            // Keep newly selected files so HttpServices.handleFiles can upload them
            if (formData['**files'] && typeof formData['**files'] === 'object') {
                const stageKeys = new Set(stageHeaders.map(h => h.key).filter(Boolean))
                const filesToUpload = {}
                Object.entries(formData['**files']).forEach(([key, value]) => {
                    if (value && stageKeys.has(key)) {
                        filesToUpload[key] = value
                    }
                })
                if (Object.keys(filesToUpload).length > 0) {
                    body['**files'] = filesToUpload
                }
            }
        }

        body = setObject(body, 'values.currentStatus', newStatusValue)
        body.populates = [
            { key: 'values.model', model: 'records', select: ['values.name'] },
            { key: 'values.colour', model: 'records', select: ['values.name'] },
            { key: 'creator', model: 'employees', select: ['name'] },
            { key: 'applet', model: 'applets', select: ['name'] },
        ]
        return body
    }

    saveStep = () => {
        const { selectedStep, stepDate, stepDescription, editHeadersOnly } = this.state
        const { fullValues, onRecordUpdated } = this.props

        if (!stepDate || !selectedStep) {
            return
        }

        // Build status object that keeps history for all stages (date & description only)
        const existingStatus = fullValues ? getObject(fullValues, 'values.currentStatus') : null

        let stages = {}
        if (existingStatus && typeof existingStatus === 'object') {
            if (existingStatus.stages && typeof existingStatus.stages === 'object') {
                stages = { ...existingStatus.stages }
            } else if (existingStatus.key) {
                stages[existingStatus.key] = {
                    date: existingStatus.date,
                    description: existingStatus.description
                }
            }
        }

        stages[selectedStep] = {
            date: stepDate,
            description: stepDescription
        }

        let newStatusValue
        if (editHeadersOnly && existingStatus && typeof existingStatus === 'object') {
            newStatusValue = {
                ...existingStatus,
                stages,
            }
        } else {
            newStatusValue = {
                ...(existingStatus && typeof existingStatus === 'object' ? existingStatus : {}),
                key: selectedStep,
                value: this.getStatusStages()[selectedStep]?.name || selectedStep,
                date: stepDate,
                description: stepDescription,
                stages
            }
        }

        const body = this.buildStageSaveBody(selectedStep, newStatusValue)
        if (!body) {
            // Required fields missing / form invalid — keep modal open, show FormViewer errors
            this.setState({ isLoading: false })
            return
        }

        this.setState({ isLoading: true })
        HttpServices.request('changeCurrentStatus', body, (result, error) => {
            this.setState({ isLoading: false })
            if (error) {
                return
            }
            this.closeStepModal()
            this.closeRoadmapModal()
            const updatedRecord = result?.info || fullValues
            if (typeof onRecordUpdated === 'function') {
                onRecordUpdated(updatedRecord)
            }
        })
    }

    getCurrentStatusValue = () => {
        const status = getObject(this.props.fullValues, 'values.currentStatus')
        if (status && status.value) {
            return status.value
        }
        return '{{lang}}No Status'
    }

    getCurrentStatusKey = () => {
        const status = getObject(this.props.fullValues, 'values.currentStatus')
        if (status && status.key) {
            return status.key
        }
        return null
    }

    getNextStep = () => {
        const currentKey = this.getCurrentStatusKey()
        if (!currentKey) {
            return this.getFirstStageKey()
        }

        const stageKeys = Object.keys(this.getStatusStages())
        const currentIndex = stageKeys.indexOf(currentKey)
        
        if (currentIndex === -1 || currentIndex === stageKeys.length - 1) {
            return null // No next steps available
        }

        // Return the next step
        return stageKeys[currentIndex + 1]
    }

    goToNextStep = () => {
        const nextStep = this.getNextStep()
        if (nextStep) {
            this.openStepModal(nextStep)
        }
    }

    viewStageDetails = (stageKey) => {
        this.setState({ viewDetailsStage: stageKey }, () => {
            if (this.detailsModal) {
                this.detailsModal.showModal()
            }
        })
    }

    closeDetailsModal = () => {
        if (this.detailsModal) {
            this.detailsModal.hideModal()
        }
        this.setState({ viewDetailsStage: null })
    }

    openInfoModal = (stageKey) => {
        this.setState({ viewInfoStage: stageKey }, () => {
            if (this.infoModal) {
                this.infoModal.showModal()
            }
        })
    }

    closeInfoModal = () => {
        if (this.infoModal) {
            this.infoModal.hideModal()
        }
        this.setState({ viewInfoStage: null })
    }

    render() {
        const { data, fullValues } = this.props
        const currentStatusValue = this.getCurrentStatusValue()
        const currentStatusKey = this.getCurrentStatusKey()
        const statusStages = this.getStatusStages()
        const stageKeys = Object.keys(statusStages)
        const currentIndex = currentStatusKey ? stageKeys.indexOf(currentStatusKey) : -1
        const nextStep = this.getNextStep()
        const statusData = getObject(fullValues, 'values.currentStatus')
        const stageConfig = this.state.selectedStep ? statusStages[this.state.selectedStep] : null
        const stageHeaders = stageConfig?.headers || []
        const canEditStages = this.hasStageEditPermission()
        const theme = siteTheme?.primaryColors || {}
        const primaryColor = theme.main1 || 'rgb(10, 45, 91)'
        const primaryColor2 = theme.main2 || 'rgb(5, 29, 61)'

        return (
            <>
                <div 
                    className="w-100 h-100 flexcc" 
                    style={{ cursor: this.props.header?.information?.canChangeFromTable ? 'pointer' : 'default' }}
                    onClick={this.openRoadmapModal}
                >
                    <p 
                        style={{ 
                            color: '#000', 
                            fontSize: '14px',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            width: '100%',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {checkTranslation(currentStatusValue)}
                    </p>
                </div>

                {/* Roadmap Modal */}
                <Modal 
                    ref={el => this.roadmapModal = el}
                    maxWidth={900}
                    dontHideOnOverlay={true}
                    cancelModal={this.closeRoadmapModal}
                >
                    <div style={{ backgroundColor: '#fff', borderRadius: 8, padding: 30 }}>
                        <h3 style={{ marginBottom: 20, textAlign: 'center' }}>
                            {checkTranslation('{{lang}}Process Roadmap')}
                        </h3>
{/*                         
                        <div style={{ 
                            marginBottom: 10,
                            fontSize: 12,
                            color: '#6b7280',
                            textAlign: 'center'
                        }}>
                            {checkTranslation('{{lang}}Scroll horizontally to see all stages')}
                        </div> */}

                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                            <button
                                onClick={() => this.scrollRoadmap('prev')}
                                style={{
                                    padding: '6px 12px',
                                    borderRadius: 16,
                                    border: '1px solid #e5e7eb',
                                    backgroundColor: '#fff',
                                    fontSize: 12,
                                    cursor: 'pointer'
                                }}
                            >
                                ‹ {checkTranslation('{{lang}}Prev')}
                            </button>
                            <button
                                onClick={() => this.scrollRoadmap('next')}
                                style={{
                                    padding: '6px 12px',
                                    borderRadius: 16,
                                    border: '1px solid #e5e7eb',
                                    backgroundColor: '#fff',
                                    fontSize: 12,
                                    cursor: 'pointer'
                                }}
                            >
                                {checkTranslation('{{lang}}Next')} ›
                            </button>
                        </div>

                        <div
                            className="no-scrollbar"
                            style={{
                                display: 'flex',
                                overflowX: 'auto',
                                padding: '20px 0',
                                marginBottom: 10,
                                cursor: this.roadmapIsDragging ? 'grabbing' : 'grab',
                                position: 'relative'
                            }}
                            ref={this.setRoadmapRef}
                            onMouseDown={this.handleRoadmapMouseDown}
                            onMouseLeave={this.handleRoadmapMouseLeave}
                            onMouseUp={this.handleRoadmapMouseUp}
                            onMouseMove={this.handleRoadmapMouseMove}
                        >
                            {stageKeys.map((stageKey, index) => {
                                const stage = statusStages[stageKey]
                                const isCompleted = currentIndex !== -1 && index < currentIndex
                                const isCurrent = index === currentIndex
                                const isFuture = currentIndex !== -1 && index > currentIndex
                                const theme = siteTheme?.primaryColors || {}
                                const primaryColor = theme.main1 || 'rgb(10, 45, 91)'
                                const primaryColor2 = theme.main2 || 'rgb(5, 29, 61)'
                                const completedColor = primaryColor
                                const futureColor = '#e5e7eb'
                                const stageHeaders = stage.headers || []
                                const canGoToThisStage = !stage.requiredPermission || checkPermission(stage.requiredPermission, null, this.getStagePermissionApplet())
                                const canViewStage = (isCompleted || isCurrent) && this.canViewStageInfo(stage)
                                const canEditStageInfo = canEditStages && index <= currentIndex && canGoToThisStage
                                
                                return (
                                    <div
                                        key={stageKey}
                                        ref={el => { if (isCurrent) this.currentStageRef = el }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            flex: '0 0 auto',
                                            minWidth: 200,
                                            position: 'relative'
                                        }}
                                    >
                                        {/* Stage Card */}
                                        <div
                                            onClick={canViewStage ? () => this.viewStageDetails(stageKey) : undefined}
                                            style={{
                                                width: 180,
                                                padding: '24px 20px',
                                                borderRadius: 12,
                                                backgroundColor: isCurrent 
                                                    ? completedColor
                                                    : isCompleted 
                                                        ? '#f0f9ff'
                                                        : '#f9fafb',
                                                border: isCurrent 
                                                    ? `3px solid ${completedColor}`
                                                    : isCompleted 
                                                        ? `2px solid ${completedColor}`
                                                        : `2px solid ${futureColor}`,
                                                cursor: canViewStage ? 'pointer' : 'default',
                                                position: 'relative',
                                                transition: 'all 0.3s ease',
                                                boxShadow: isCurrent 
                                                    ? `0 8px 24px ${primaryColor}33`
                                                    : isCompleted 
                                                        ? `0 4px 12px ${primaryColor}22`
                                                        : '0 2px 4px rgba(0,0,0,0.05)',
                                                opacity: isFuture ? 0.4 : 1,
                                                transform: isCurrent ? 'scale(1.05)' : 'scale(1)',
                                                zIndex: isCurrent ? 10 : isCompleted ? 5 : 1
                                            }}
                                            onMouseEnter={(e) => {
                                                if (canViewStage) {
                                                    e.currentTarget.style.transform = isCurrent ? 'scale(1.08)' : 'scale(1.03)'
                                                    e.currentTarget.style.boxShadow = `0 8px 24px ${primaryColor}44`
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = isCurrent ? 'scale(1.05)' : 'scale(1)'
                                                e.currentTarget.style.boxShadow = isCurrent 
                                                    ? `0 8px 24px ${primaryColor}33`
                                                    : isCompleted 
                                                        ? `0 4px 12px ${primaryColor}22`
                                                        : '0 2px 4px rgba(0,0,0,0.05)'
                                            }}
                                        >
                                            {/* Stage Number Badge */}
                                            <div style={{
                                                position: 'absolute',
                                                top: -12,
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                width: 32,
                                                height: 32,
                                                borderRadius: '50%',
                                                backgroundColor: isCurrent || isCompleted ? completedColor : futureColor,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#fff',
                                                fontSize: 14,
                                                fontWeight: 'bold',
                                                boxShadow: isCurrent || isCompleted 
                                                    ? `0 4px 8px ${primaryColor}44`
                                                    : '0 2px 4px rgba(0,0,0,0.1)',
                                                border: '3px solid #fff'
                                            }}>
                                                {isCompleted ? '✓' : isCurrent ? '●' : index + 1}
                                            </div>

                                            {/* Stage Name */}
                                            <div style={{ 
                                                fontSize: 13, 
                                                fontWeight: '600',
                                                marginTop: 12,
                                                marginBottom: 8,
                                                color: isCurrent 
                                                    ? '#fff'
                                                    : isCompleted 
                                                        ? completedColor
                                                        : '#9ca3af',
                                                textAlign: 'center',
                                                lineHeight: '1.4',
                                                minHeight: 36
                                            }}>
                                                {checkTranslation(stage.name)}
                                            </div>

                                            {/* Status Indicator */}
                                            {(isCompleted || isCurrent) && (
                                                <div style={{
                                                    marginTop: 8,
                                                    padding: '6px 12px',
                                                    borderRadius: 20,
                                                    backgroundColor: isCurrent 
                                                        ? 'rgba(255,255,255,0.2)'
                                                        : completedColor + '15',
                                                    color: isCurrent ? '#fff' : completedColor,
                                                    fontSize: 11,
                                                    fontWeight: '600',
                                                    textAlign: 'center'
                                                }}>
                                                    {isCurrent ? checkTranslation('{{lang}}Current') : checkTranslation('{{lang}}Completed')}
                                                </div>
                                            )}

                                            {/* View Details Badge — only when user has this stage's advanceFor */}
                                            {canViewStage && (
                                                <div style={{
                                                    marginTop: 8,
                                                    fontSize: 10,
                                                    color: isCurrent ? 'rgba(255,255,255,0.9)' : completedColor,
                                                    textAlign: 'center',
                                                    fontWeight: '500'
                                                }}>
                                                    <img
                                                        src="/images/carrow.svg"
                                                        alt={checkTranslation('{{lang}}Click to view')}
                                                        style={{
                                                            width: 14,
                                                            height: 14,
                                                            transform: 'rotate(90deg)', // right arrow -> down
                                                            opacity: isCurrent ? 0.95 : 0.85,
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            {/* Advanced stage controls — jump requires admin.permissions.edit */}
                                            {((canEditStages && !isCurrent) || canEditStageInfo) && (
                                                <div style={{
                                                    marginTop: 10,
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: 6,
                                                    justifyContent: 'center'
                                                }}>
                                                    {canEditStages && !isCurrent && (
                                                        <button
                                                            type="button"
                                                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.openStepModal(stageKey, { editHeadersOnly: false }); }}
                                                            style={{
                                                                padding: '4px 10px',
                                                                borderRadius: 999,
                                                                border: '1px solid rgba(148,163,184,0.8)',
                                                                backgroundColor: '#fff',
                                                                color: '#0f172a',
                                                                fontSize: 11,
                                                                fontWeight: 600,
                                                                cursor: 'pointer',
                                                                transition: 'all 0.2s'
                                                            }}
                                                        >
                                                            {checkTranslation('{{lang}}Go to this stage')}
                                                        </button>
                                                    )}
                                                    {canEditStageInfo && (
                                                        <button
                                                            type="button"
                                                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.openStepModal(stageKey, { editHeadersOnly: true }); }}
                                                            style={{
                                                                padding: '4px 10px',
                                                                borderRadius: 999,
                                                                border: isCurrent ? '1px solid rgba(255,255,255,0.6)' : `1px solid ${primaryColor}4d`,
                                                                backgroundColor: isCurrent ? 'rgba(255,255,255,0.2)' : `${primaryColor}12`,
                                                                color: isCurrent ? '#fff' : primaryColor,
                                                                fontSize: 11,
                                                                fontWeight: 600,
                                                                cursor: 'pointer',
                                                                transition: 'all 0.2s'
                                                            }}
                                                        >
                                                            {checkTranslation('{{lang}}Edit stage info')}
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        {/* Connecting Line */}
                                        {index < stageKeys.length - 1 && (
                                            <div style={{
                                                width: 40,
                                                height: 3,
                                                backgroundColor: isCompleted ? completedColor : futureColor,
                                                position: 'relative',
                                                margin: '0 10px',
                                                opacity: isFuture ? 0.3 : 1
                                            }}>
                                                {/* Animated dot on completed lines */}
                                                {isCompleted && (
                                                    <div style={{
                                                        position: 'absolute',
                                                        right: -4,
                                                        top: -4,
                                                        width: 11,
                                                        height: 11,
                                                        borderRadius: '50%',
                                                        backgroundColor: completedColor,
                                                        border: '2px solid #fff',
                                                        boxShadow: `0 2px 4px ${primaryColor}44`
                                                    }} />
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div>

                        {nextStep && !this.props.header?.information?.cantEdit && (() => {
                            const advancePermissionStage = this.getAdvancePermissionStage()
                            const advanceApplet = this.getStagePermissionApplet()
                            const canAdvance = this.canAdvanceForStage(advancePermissionStage)
                            const hasNextPermission = !advancePermissionStage?.requiredPermission || checkPermission(advancePermissionStage.requiredPermission, null, advanceApplet)
                            return canAdvance && hasNextPermission
                        })() && (
                            <div style={{ marginTop: 30, textAlign: 'center' }}>
                                <button
                                    onClick={this.goToNextStep}
                                    style={{
                                        padding: '12px 40px',
                                        borderRadius: 25,
                                        border: 'none',
                                        background: `linear-gradient(90deg, ${primaryColor}, ${primaryColor2})`,
                                        color: '#fff',
                                        cursor: 'pointer',
                                        fontSize: 14,
                                        fontWeight: '600',
                                        boxShadow: `0 4px 12px ${primaryColor}44`,
                                        transition: 'all 0.3s'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-2px)'
                                        e.target.style.boxShadow = `0 6px 16px ${primaryColor}55`
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)'
                                        e.target.style.boxShadow = `0 4px 12px ${primaryColor}44`
                                    }}
                                >
                                    {checkTranslation('{{lang}}Go to Next Stage')}: {checkTranslation(statusStages[nextStep]?.name || '')}
                                </button>
                            </div>
                        )}

                        <div style={{ marginTop: 20, textAlign: 'center' }}>
                            <button
                                onClick={this.closeRoadmapModal}
                                style={{
                                    padding: '10px 30px',
                                    borderRadius: 20,
                                    border: '1px solid #e5e7eb',
                                    backgroundColor: '#fff',
                                    color: '#6b7280',
                                    cursor: 'pointer',
                                    fontSize: 14
                                }}
                            >
                                {checkTranslation('{{lang}}Close')}
                            </button>
                        </div>
                    </div>
                </Modal>

                {/* Step Selection Modal */}
                <Modal 
                    ref={el => this.stepModal = el}
                    maxWidth={800}
                    dontHideOnOverlay={true}
                    cancelModal={this.closeStepModal}
                >
                    <div style={{ backgroundColor: '#fff', borderRadius: 12, padding: 40 }}>
                        <h3 style={{ marginBottom: 30, textAlign: 'center', fontSize: 24, fontWeight: '600', color: '#1f2937' }}>
                            {checkTranslation('{{lang}}Update Step')}
                        </h3>
                        
                        {this.state.selectedStep && (() => {
                            const stage = statusStages[this.state.selectedStep]
                            const hasMoreInfo = Array.isArray(stage?.moreInfo) && stage.moreInfo.length > 0
                            return (
                                <div style={{ 
                                    marginBottom: 30, 
                                    padding: 16, 
                                    backgroundColor: stage?.color + '15',
                                    borderRadius: 8,
                                    border: '2px solid #10453d',
                                    textAlign: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 10,
                                }}>
                                    <div style={{ 
                                        fontSize: 16, 
                                        fontWeight: '600',
                                        color: '#10453d'
                                    }}>
                                        {checkTranslation(stage?.name || this.state.selectedStep)}
                                    </div>
                                    {hasMoreInfo && (
                                        <button
                                            onClick={() => this.openInfoModal(this.state.selectedStep)}
                                            style={{
                                                padding: '6px 14px',
                                                borderRadius: 999,
                                                border: '1px solid rgba(59,130,246,0.4)',
                                                background: 'linear-gradient(135deg, #eff6ff, #e0f2fe)',
                                                color: '#1d4ed8',
                                                fontSize: 11,
                                                fontWeight: 600,
                                                cursor: 'pointer',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 6
                                            }}
                                        >
                                            <span>ℹ️</span>
                                            <span>{checkTranslation('{{lang}}View stage info')}</span>
                                        </button>
                                    )}
                                </div>
                            )
                        })()}

                        <div style={{ 
                            marginBottom: 24, 
                            padding: 20,
                            backgroundColor: '#f9fafb',
                            borderRadius: 8,
                            border: '2px solid #e5e7eb'
                        }}>
                            <label style={{ 
                                display: 'block', 
                                marginBottom: 12, 
                                fontWeight: '600',
                                fontSize: 14,
                                color: '#374151'
                            }}>
                                {checkTranslation('{{lang}}Date')} <span style={{ color: '#ef4444' }}>*</span>
                            </label>
                            <div style={{
                                backgroundColor: '#fff',
                                border: '2px solid #d1d5db',
                                borderRadius: 8,
                                padding: '4px',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                minHeight: 45
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = '#6366f1'
                                e.currentTarget.style.boxShadow = '0 0 0 3px rgba(99, 102, 241, 0.1)'
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = '#d1d5db'
                                e.currentTarget.style.boxShadow = 'none'
                            }}
                            >
                                <DateInput
                                    header={{
                                        key: 'stepDate',
                                        information: {
                                            label: checkTranslation('{{lang}}Date'),
                                            required: true
                                        }
                                    }}
                                    changeValue={this.handleStepDateChange}
                                    data={this.state.stepDate}
                                />
                            </div>
                            {!this.state.stepDate && (
                                <p style={{ marginTop: 8, fontSize: 12, color: '#ef4444' }}>
                                    {checkTranslation('{{lang}}Please select a date')}
                                </p>
                            )}
                        </div>

                        {stageHeaders.length > 0 && (
                            <div style={{ 
                                marginBottom: 24, 
                                padding: 20,
                                backgroundColor: '#f9fafb',
                                borderRadius: 8,
                                border: '2px solid #e5e7eb'
                            }}>
                                <label style={{ 
                                    display: 'block', 
                                    marginBottom: 12, 
                                    fontWeight: '600',
                                    fontSize: 14,
                                    color: '#374151'
                                }}>
                                    {checkTranslation('{{lang}}Additional Information')}
                                </label>
                                <FormViewer
                                    ref={el => this.stageForm = el}
                                    headers={stageHeaders}
                                    initData={this.props.fullValues || {}}
                                    inputClass={'modern-input'}
                                />
                            </div>
                        )}

                        <div style={{ 
                            marginBottom: 30,
                            padding: 20,
                            backgroundColor: '#f9fafb',
                            borderRadius: 8,
                            border: '2px solid #e5e7eb'
                        }}>
                            <label style={{ 
                                display: 'block', 
                                marginBottom: 12, 
                                fontWeight: '600',
                                fontSize: 14,
                                color: '#374151'
                            }}>
                                {checkTranslation('{{lang}}Description')} <span style={{ color: '#9ca3af', fontSize: 12 }}>({checkTranslation('{{lang}}Optional')})</span>
                            </label>
                            <div style={{
                                backgroundColor: '#fff',
                                border: '2px solid #d1d5db',
                                borderRadius: 8,
                                padding: '4px',
                                minHeight: 100,
                                transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = '#6366f1'
                                e.currentTarget.style.boxShadow = '0 0 0 3px rgba(99, 102, 241, 0.1)'
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = '#d1d5db'
                                e.currentTarget.style.boxShadow = 'none'
                            }}
                            >
                                <TextAreaInput
                                    header={{
                                        key: 'stepDescription',
                                        information: {
                                            label: checkTranslation('{{lang}}Description'),
                                            required: false,
                                            rows: 4
                                        }
                                    }}
                                    changeValue={this.handleStepDescriptionChange}
                                    data={this.state.stepDescription}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 30 }}>
                            <button
                                onClick={this.closeStepModal}
                                style={{
                                    padding: '12px 32px',
                                    borderRadius: 8,
                                    border: '2px solid #e5e7eb',
                                    backgroundColor: '#fff',
                                    color: '#6b7280',
                                    cursor: 'pointer',
                                    fontSize: 14,
                                    fontWeight: '600',
                                    transition: 'all 0.2s',
                                    minWidth: 120
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.borderColor = '#d1d5db'
                                    e.target.style.backgroundColor = '#f9fafb'
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.borderColor = '#e5e7eb'
                                    e.target.style.backgroundColor = '#fff'
                                }}
                            >
                                {checkTranslation('{{lang}}Cancel')}
                            </button>
                            <button
                                onClick={this.saveStep}
                                disabled={this.state.isLoading || !this.state.stepDate}
                                style={{
                                    padding: '12px 32px',
                                    borderRadius: 8,
                                    border: 'none',
                                    background: this.state.isLoading || !this.state.stepDate
                                        ? '#d1d5db'
                                        : `linear-gradient(90deg, ${siteTheme?.primaryColors?.main1 || 'rgb(10, 45, 91)'}, ${siteTheme?.primaryColors?.main2 || 'rgb(5, 29, 61)'})`,
                                    color: '#fff',
                                    cursor: this.state.isLoading || !this.state.stepDate ? 'not-allowed' : 'pointer',
                                    fontSize: 14,
                                    fontWeight: '600',
                                    transition: 'all 0.2s',
                                    minWidth: 120,
                                    boxShadow: this.state.isLoading || !this.state.stepDate ? 'none' : `0 4px 12px ${(siteTheme?.primaryColors?.main1 || 'rgb(10, 45, 91)')}44`
                                }}
                                onMouseEnter={(e) => {
                                    if (!this.state.isLoading && this.state.stepDate) {
                                        e.target.style.transform = 'translateY(-2px)'
                                        e.target.style.boxShadow = '0 6px 16px rgba(0,0,0,0.2)'
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!this.state.isLoading && this.state.stepDate) {
                                        e.target.style.transform = 'translateY(0)'
                                        e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'
                                    }
                                }}
                            >
                                {this.state.isLoading 
                                    ? checkTranslation('{{lang}}Saving...') 
                                    : checkTranslation('{{lang}}Save')}
                            </button>
                        </div>
                    </div>
                </Modal>

                {/* Stage Details Modal */}
                <Modal 
                    ref={el => this.detailsModal = el}
                    maxWidth={800}
                    dontHideOnOverlay={true}
                    cancelModal={this.closeDetailsModal}
                >
                    <div style={{ backgroundColor: '#fff', borderRadius: 16, padding: 0, overflow: 'hidden' }}>
                        {this.state.viewDetailsStage && (() => {
                            const stage = statusStages[this.state.viewDetailsStage]
                            const theme = siteTheme?.primaryColors || {}
                            const primaryColor = theme.main1 || 'rgb(10, 45, 91)'
                            const primaryColor2 = theme.main2 || 'rgb(5, 29, 61)'

                            let stageData = null
                            if (statusData && typeof statusData === 'object') {
                                // Prefer per-stage history if available
                                if (statusData.stages && typeof statusData.stages === 'object') {
                                    stageData = statusData.stages[this.state.viewDetailsStage] || null
                                }
                                // Backward compatibility: old shape where the whole object was one stage
                                if (!stageData && statusData.key === this.state.viewDetailsStage) {
                                    stageData = statusData
                                }
                            }

                            const stageDetailHeaders = this.getReadOnlyHeaders(stage?.headers)
                            const hasStageMeta = !!(stageData && (stageData.date || stageData.description))
                            const hasHeaderFields = stageDetailHeaders.length > 0
                            const hasMoreInfo = Array.isArray(stage?.moreInfo) && stage.moreInfo.length > 0
                            
                            return (
                                <>
                                    {/* Header with stage color */}
                                    <div style={{ 
                                        background: `linear-gradient(90deg, ${primaryColor}, ${primaryColor2})`,
                                        padding: '32px 30px',
                                        color: '#fff',
                                        position: 'relative'
                                    }}>
                                        <div style={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            width: 200,
                                            height: 200,
                                            borderRadius: '50%',
                                            background: 'rgba(255,255,255,0.1)',
                                            transform: 'translate(30%, -30%)'
                                        }} />
                                        <div style={{ position: 'relative', zIndex: 1 }}>
                                            <div style={{ 
                                                fontSize: 24, 
                                                fontWeight: 'bold',
                                                marginBottom: 8,
                                                textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                            }}>
                                                {checkTranslation(stage.name)}
                                            </div>
                                            <div style={{ 
                                                fontSize: 14, 
                                                opacity: 0.9,
                                                fontWeight: '500'
                                            }}>
                                                {checkTranslation('{{lang}}Stage Details')}
                                            </div>
                                            {hasMoreInfo && (
                                                <button
                                                    type="button"
                                                    onClick={() => this.openInfoModal(this.state.viewDetailsStage)}
                                                    style={{
                                                        marginTop: 12,
                                                        padding: '6px 14px',
                                                        borderRadius: 999,
                                                        border: '1px solid rgba(255,255,255,0.5)',
                                                        background: 'rgba(255,255,255,0.2)',
                                                        color: '#fff',
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        cursor: 'pointer',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: 6
                                                    }}
                                                >
                                                    <span>ℹ️</span>
                                                    <span>{checkTranslation('{{lang}}View stage info')}</span>
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <div style={{ padding: '30px' }}>
                                        {(hasStageMeta || hasHeaderFields) ? (
                                            <div>
                                                {stageData?.date && (
                                                    <div style={{ 
                                                        marginBottom: 24,
                                                        padding: '20px',
                                                        borderRadius: 12,
                                                        backgroundColor: '#f9fafb',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            marginBottom: 8
                                                        }}>
                                                            <div style={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: '50%',
                                                                backgroundColor: primaryColor + '15',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                marginRight: 12,
                                                                color: primaryColor,
                                                                fontSize: 18
                                                            }}>
                                                                📅
                                                            </div>
                                                            <div>
                                                                <div style={{ 
                                                                    fontSize: 12, 
                                                                    fontWeight: '600',
                                                                    color: '#6b7280',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.5px',
                                                                    marginBottom: 4
                                                                }}>
                                                                    {checkTranslation('{{lang}}Date')}
                                                                </div>
                                                                <div style={{ 
                                                                    fontSize: 16, 
                                                                    fontWeight: '600',
                                                                    color: '#1f2937'
                                                                }}>
                                                                    {new Date(stageData.date).toLocaleDateString('en-US', { 
                                                                        year: 'numeric', 
                                                                        month: 'long', 
                                                                        day: 'numeric' 
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {stageData?.description && (
                                                    <div style={{ 
                                                        marginBottom: 24,
                                                        padding: '20px',
                                                        borderRadius: 12,
                                                        backgroundColor: '#f9fafb',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'flex-start',
                                                            marginBottom: 12
                                                        }}>
                                                            <div style={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: '50%',
                                                                backgroundColor: primaryColor + '15',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                marginRight: 12,
                                                                color: primaryColor,
                                                                fontSize: 18,
                                                                flexShrink: 0
                                                            }}>
                                                                📝
                                                            </div>
                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ 
                                                                    fontSize: 12, 
                                                                    fontWeight: '600',
                                                                    color: '#6b7280',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.5px',
                                                                    marginBottom: 8
                                                                }}>
                                                                    {checkTranslation('{{lang}}Description')}
                                                                </div>
                                                                <div style={{ 
                                                                    fontSize: 15, 
                                                                    color: '#374151',
                                                                    lineHeight: '1.6',
                                                                    whiteSpace: 'pre-wrap'
                                                                }}>
                                                                    {stageData.description}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {hasHeaderFields && (
                                                    <div style={{
                                                        marginBottom: 24,
                                                        padding: '20px',
                                                        borderRadius: 12,
                                                        backgroundColor: '#f9fafb',
                                                        border: '1px solid #e5e7eb'
                                                    }}>
                                                        <div style={{
                                                            fontSize: 12,
                                                            fontWeight: '600',
                                                            color: '#6b7280',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            marginBottom: 16
                                                        }}>
                                                            {checkTranslation('{{lang}}Additional Information')}
                                                        </div>
                                                        <FormViewer
                                                            headers={stageDetailHeaders}
                                                            initData={fullValues || {}}
                                                            inputClass={'modern-input'}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div style={{
                                                padding: '40px 20px',
                                                textAlign: 'center',
                                                borderRadius: 12,
                                                backgroundColor: '#f9fafb',
                                                border: '2px dashed #e5e7eb'
                                            }}>
                                                <div style={{
                                                    fontSize: 48,
                                                    marginBottom: 16,
                                                    opacity: 0.5
                                                }}>
                                                    📋
                                                </div>
                                                <div style={{ 
                                                    fontSize: 16, 
                                                    color: '#9ca3af',
                                                    fontWeight: '500'
                                                }}>
                                                    {checkTranslation('{{lang}}No details available')}
                                                </div>
                                            </div>
                                        )}

                                        {/* Close Button */}
                                        <div style={{ textAlign: 'center', marginTop: 30 }}>
                                            <button
                                                onClick={this.closeDetailsModal}
                                                style={{
                                                    padding: '12px 40px',
                                                    borderRadius: 25,
                                                    border: 'none',
                                                    background: `linear-gradient(90deg, ${primaryColor}, ${primaryColor2})`,
                                                    color: '#fff',
                                                    cursor: 'pointer',
                                                    fontSize: 14,
                                                    fontWeight: '600',
                                                    boxShadow: `0 4px 12px ${primaryColor}44`,
                                                    transition: 'all 0.3s'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'translateY(-2px)'
                                                    e.target.style.boxShadow = `0 6px 16px ${primaryColor}55`
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'translateY(0)'
                                                    e.target.style.boxShadow = `0 4px 12px ${primaryColor}44`
                                                }}
                                            >
                                                {checkTranslation('{{lang}}Close')}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )
                        })()}
                    </div>
                </Modal>

                {/* Stage Info Modal (read-only moreInfo headers) */}
                <Modal 
                    ref={el => this.infoModal = el}
                    maxWidth={700}
                    dontHideOnOverlay={true}
                    cancelModal={this.closeInfoModal}
                >
                    <div style={{ backgroundColor: '#0f172a', borderRadius: 18, padding: 2 }}>
                        <div style={{
                            backgroundColor: '#ffffff',
                            borderRadius: 16,
                            padding: '26px 28px 24px 28px'
                        }}>
                            {this.state.viewInfoStage && (() => {
                                const stage = statusStages[this.state.viewInfoStage]
                                const primaryColor = stage?.color || '#10453d'
                                const rawHeaders = Array.isArray(stage?.moreInfo) ? stage.moreInfo : []
                                const infoHeaders = rawHeaders.map(h => ({
                                    ...h,
                                    information: {
                                        ...(h.information || {}),
                                        disabled: true,
                                        required: false
                                    }
                                }))

                                return (
                                    <>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            marginBottom: 18
                                        }}>
                                            <div>
                                                <div style={{
                                                    fontSize: 13,
                                                    fontWeight: 600,
                                                    color: '#6b7280',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.08em',
                                                    marginBottom: 4
                                                }}>
                                                    {checkTranslation('{{lang}}Stage info')}
                                                </div>
                                                <div style={{
                                                    fontSize: 20,
                                                    fontWeight: 700,
                                                    color: '#0f172a'
                                                }}>
                                                    {checkTranslation(stage?.name || this.state.viewInfoStage)}
                                                </div>
                                            </div>
                                            <div style={{
                                                width: 40,
                                                height: 40,
                                                borderRadius: '999px',
                                                background: primaryColor + '22',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: primaryColor,
                                                fontSize: 20,
                                                boxShadow: `0 4px 14px ${primaryColor}33`
                                            }}>
                                                ℹ️
                                            </div>
                                        </div>

                                        <div style={{
                                            padding: 18,
                                            borderRadius: 12,
                                            border: '1px solid #e5e7eb',
                                            backgroundColor: '#f9fafb',
                                            marginBottom: 18
                                        }}>
                                            {infoHeaders.length > 0 ? (
                                                <FormViewer
                                                    headers={infoHeaders}
                                                    initData={this.props.fullValues || {}}
                                                    inputClass={'modern-input'}
                                                />
                                            ) : (
                                                <p style={{ fontSize: 13, color: '#9ca3af', margin: 0 }}>
                                                    {checkTranslation('{{lang}}No additional info configured for this stage')}
                                                </p>
                                            )}
                                        </div>

                                        <div style={{ textAlign: 'right' }}>
                                            <button
                                                onClick={this.closeInfoModal}
                                                style={{
                                                    padding: '8px 22px',
                                                    borderRadius: 999,
                                                    border: 'none',
                                                    backgroundColor: primaryColor,
                                                    color: '#fff',
                                                    fontSize: 13,
                                                    fontWeight: 600,
                                                    cursor: 'pointer',
                                                    boxShadow: `0 6px 18px ${primaryColor}44`
                                                }}
                                            >
                                                {checkTranslation('{{lang}}Close')}
                                            </button>
                                        </div>
                                    </>
                                )
                            })()}
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TableProfessionalStatusInput);

